import { WEATHER_DETAIL_ICON_KEYS } from 'features/Weather/config/weatherDetailIcons.config';
import { formatDateTime } from 'utils/dates/date.utils';
import { displayValue, displayValueWithUnit } from 'utils/valueFormatting/display.utils';
import { formatEarthquakeCoordinates } from '../utils/earthquakes.utils';

export const earthquakeDetails = [
  {
    id: 'magnitude',
    label: 'Magnitude',
    iconKey: WEATHER_DETAIL_ICON_KEYS.MAGNITUDE,
    getValue: (earthquake) => displayValue(earthquake?.magnitude),
  },
  {
    id: 'depth',
    label: 'Depth',
    iconKey: WEATHER_DETAIL_ICON_KEYS.DEPTH,
    getValue: (earthquake) => displayValueWithUnit(earthquake?.depth, ' km'),
  },
  {
    id: 'occurrence',
    label: 'Occurred',
    iconKey: WEATHER_DETAIL_ICON_KEYS.TIME,
    getValue: (earthquake) => formatDateTime(earthquake?.occurrence),
  },
  {
    id: 'coordinates',
    label: 'Coordinates',
    iconKey: WEATHER_DETAIL_ICON_KEYS.LOCATION,
    getValue: formatEarthquakeCoordinates,
  },
];

export const earthquakeDetailGroups = [
  ['magnitude', 'depth'],
  ['occurrence', 'coordinates'],
];
